import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _toConsumableArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

var _templateObject;

import { useField } from 'formik';
import styled from 'styled-components';
import { AnimatePresence, motion } from 'framer-motion';
import { Trans, useTranslation } from '@yoweb/next-i18next';
import theme from '@yoweb/ui/styles/theme';
import { Flex } from '@yoweb/ui/components/Flex';
import { Grid } from '@yoweb/ui/components/Grid';
import { th } from '@yoweb/ui/styles/utils/theme';
import { StarPicker } from '@yoweb/ui/components/StarPicker';
import { Text, Title } from '@yoweb/ui/components/typography';
import { CheckThinIcon } from '@yoweb/ui/components/Icon/CheckThinIcon';
import { Button } from '@yoweb/ui/components/buttons';
import { ActionModalFooter } from '@poplar/components/ActionModal';
import { FlyoutContent, FlyoutContentContainer, FlyoutTextContainer, StepHeader, StepGrid } from './Common';
import { FlyoutButton } from '@poplar/components/Flyout/FlyoutTodo/common';
import { media } from '@yoweb/ui/styles/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var ratingToTranslation = function ratingToTranslation(rating) {
  switch (rating) {
    case 1:
      return 'todo-feedback.rating-to-response.1';

    case 2:
      return 'todo-feedback.rating-to-response.2';

    case 3:
      return 'todo-feedback.rating-to-response.3';

    case 4:
      return 'todo-feedback.rating-to-response.4';

    case 5:
      return 'todo-feedback.rating-to-response.5';

    default:
      return;
  }
};

export var OverallStep = function OverallStep(_ref) {
  var _generalCategories$ca;

  var taskFeedback = _ref.taskFeedback,
      feedbackCategories = _ref.feedbackCategories,
      isSubmitting = _ref.isSubmitting,
      onNext = _ref.onNext,
      onHelpStillNeeded = _ref.onHelpStillNeeded,
      onSkipFeedback = _ref.onSkipFeedback;

  var _useTranslation = useTranslation('tasks'),
      t = _useTranslation.t;

  var _useField = useField('generalFeedbackV2.specificFeedbackList'),
      _useField2 = _slicedToArray(_useField, 3),
      specificFeedbackListField = _useField2[0],
      specificFeedbackListHelpers = _useField2[2];

  var _useField3 = useField('generalFeedbackV2.starRating'),
      _useField4 = _slicedToArray(_useField3, 3),
      starRatingField = _useField4[0],
      starRatingHelpers = _useField4[2];

  var _useField5 = useField('feedbackSkipped'),
      _useField6 = _slicedToArray(_useField5, 3),
      skipFeedbackHelpers = _useField6[2];

  var generalCategories = feedbackCategories.find(function (_ref2) {
    var type = _ref2.type;
    return type === 'general';
  });
  var starValue = starRatingField.value;
  var selectedFeedback = specificFeedbackListField.value;

  var handleToggleButton = function handleToggleButton(key) {
    var selectedValue = selectedFeedback.find(function (_ref3) {
      var name = _ref3.name;
      return name === key;
    });

    if (selectedValue) {
      specificFeedbackListHelpers.setValue(selectedFeedback.filter(function (value) {
        return value !== selectedValue;
      }));
    } else {
      specificFeedbackListHelpers.setValue([].concat(_toConsumableArray(selectedFeedback), [{
        name: key
      }]));
    }
  };

  var handleOnSkipClicked = function handleOnSkipClicked() {
    skipFeedbackHelpers.setValue(true);
    skipFeedbackHelpers.setTouched(true);
    onSkipFeedback();
  };

  var ratingTranslation = ratingToTranslation(starValue);
  var ratingToTranslationLabel = ratingTranslation && t(ratingTranslation);
  return /*#__PURE__*/_jsxs(FlyoutContentContainer, {
    "data-testid": "overall-feedback-step",
    children: [/*#__PURE__*/_jsx(FlyoutContent, {
      children: /*#__PURE__*/_jsxs(StepGrid, {
        children: [/*#__PURE__*/_jsx(StepHeader, {
          taskFeedback: taskFeedback
        }), /*#__PURE__*/_jsxs(Grid, {
          gap: "medium1",
          children: [/*#__PURE__*/_jsxs(Flex, {
            gap: "normal2",
            justifyItems: "left",
            alignItems: "left",
            flexDirection: "column",
            children: [/*#__PURE__*/_jsx(Title, {
              size: "sm",
              as: "h3",
              lineHeight: "interactiveLg",
              children: t('todo-feedback.title')
            }), /*#__PURE__*/_jsx(StarPicker, {
              count: 5,
              size: 48,
              value: starValue,
              onChange: function onChange(value) {
                if (starValue !== value) {
                  starRatingHelpers.setValue(value); // clear selected pills

                  specificFeedbackListHelpers.setValue([]);
                  starRatingHelpers.setTouched(true);
                }
              }
            })]
          }), /*#__PURE__*/_jsxs(Flex, {
            gap: "normal3",
            justifyItems: "left",
            alignItems: "left",
            flexDirection: "column",
            children: [/*#__PURE__*/_jsx(AnimatePresence, {
              children: starValue > 0 && /*#__PURE__*/_jsx(motion.div, {
                initial: selectedFeedback.length > 0 ? 'initial' : {
                  opacity: 0,
                  height: 0
                },
                exit: {
                  opacity: 0,
                  height: 0
                },
                animate: {
                  opacity: 1,
                  height: 'auto'
                },
                transition: {
                  duration: theme.transitionDuration["short"] / 1000
                },
                children: /*#__PURE__*/_jsxs(Grid, {
                  gap: "normal2",
                  children: [/*#__PURE__*/_jsx(Text, {
                    weight: "bold",
                    textAlign: "left",
                    children: ratingToTranslationLabel
                  }), /*#__PURE__*/_jsx(CategoryContainer, {
                    "data-testid": "feedback-categories",
                    children: generalCategories === null || generalCategories === void 0 ? void 0 : (_generalCategories$ca = generalCategories.categoriesList) === null || _generalCategories$ca === void 0 ? void 0 : _generalCategories$ca.map(function (category) {
                      var selected = selectedFeedback.some(function (_ref4) {
                        var name = _ref4.name;
                        return category.key === name;
                      });
                      return /*#__PURE__*/_jsx(CategoryToggleButton, {
                        type: "button",
                        variant: "secondary",
                        selected: selected,
                        "aria-pressed": selected,
                        iconLeft: /*#__PURE__*/_jsx(CheckmarkIcon, {
                          selected: selected,
                          size: 24
                        }),
                        "data-testid": "feedback-category-".concat(category.key),
                        onClick: function onClick() {
                          return handleToggleButton(category.key);
                        },
                        children: category.text
                      }, category.key);
                    })
                  })]
                })
              }, "rating-feedback-response")
            }), /*#__PURE__*/_jsxs(FeedbackTextSection, {
              children: [/*#__PURE__*/_jsx(SubHead, {
                children: /*#__PURE__*/_jsx(Trans, {
                  t: t,
                  i18nKey: "todo-feedback.needs-subhead"
                })
              }), /*#__PURE__*/_jsx(Text, {
                children: /*#__PURE__*/_jsx(Trans, {
                  t: t,
                  i18nKey: "todo-feedback.needs-body"
                })
              }), /*#__PURE__*/_jsx(ReopenCtaContainer, {
                children: /*#__PURE__*/_jsx(Button, {
                  onClick: onHelpStillNeeded,
                  type: "button",
                  size: "md",
                  variant: "secondary",
                  children: t('todo-feedback.needs-cta')
                })
              })]
            })]
          })]
        })]
      })
    }), /*#__PURE__*/_jsxs(ActionModalFooter, {
      children: [/*#__PURE__*/_jsx(FlyoutButton, {
        size: "lg",
        type: "button",
        disabled: starValue === 0,
        isLoading: isSubmitting,
        "data-testid": "todo-feedback-next-button",
        onClick: onNext,
        children: t('actions.continue', {
          ns: 'common'
        })
      }), /*#__PURE__*/_jsx(FlyoutButton, {
        size: "lg",
        type: "button",
        variant: "secondary",
        disabled: isSubmitting,
        "data-testid": "todo-feedback-skip-feedback-button",
        onClick: handleOnSkipClicked,
        children: t('skip-feedback')
      })]
    })]
  });
};
var CheckmarkIcon = styled(CheckThinIcon).withConfig({
  componentId: "sc-ruvzdm-0"
})(["&&{color:", ";}"], function (_ref5) {
  var selected = _ref5.selected;
  return selected ? th.getColor('base900') : th.getColor('base200');
});
var CategoryToggleButton = styled(Button).withConfig({
  componentId: "sc-ruvzdm-1"
})(["&&{transition:all;transition-duration:", "ms;background:", ";border:1px solid ", ";&:hover{background:", ";}}"], th.getDuration('interaction'), function (_ref6) {
  var selected = _ref6.selected;
  return th.getColor(selected ? 'gingko' : 'base000');
}, function (_ref7) {
  var selected = _ref7.selected;
  return selected ? 'transparent' : th.getColor('base900');
}, function (_ref8) {
  var selected = _ref8.selected;
  return th.getColor(selected ? 'gingko' : 'base000');
});
var CategoryContainer = styled.div.withConfig({
  componentId: "sc-ruvzdm-2"
})(["display:flex;gap:", ";flex-wrap:wrap;align-items:left;justify-content:left;justify-self:left;max-width:90%;"], th.getSpace('normal1'));
var SubHead = styled(Text).withConfig({
  componentId: "sc-ruvzdm-3"
})(["font-weight:bold;margin-bottom:", ";"], th.getSpace('small2'));
var ReopenCtaContainer = styled.div.withConfig({
  componentId: "sc-ruvzdm-4"
})(["max-width:30%;padding-top:", ";"], th.getSpace('normal1'));
var FeedbackTextSection = styled(FlyoutTextContainer).withConfig({
  componentId: "sc-ruvzdm-5"
})(["&&{", "}"], media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      max-width: 85%;\n    "]))));